import { IUser, IUserDateTimeFormat } from '../index'
import { IUserData } from '../request/response'

export default function(item: IUserData): IUser & IUserDateTimeFormat {
  return {
    createDate: new Date(Number(item.create_date) * 1000),
    dateFormat: item.date_format,
    email: item.email,
    id: item.id,
    savedLanguage: item.saved_lang,
    timeFormat: item.time_format,
    promotionUsed: item.promotion_used,
    userPriceGroup: item.user_price_group,
    booking_property_id: item.booking_property_id,
    booking_integration_status: item.booking_integration_status,
    booking_currency: item.booking_currency,
    debug_mode: Boolean(Number(item.debug_mode)),
    id_owner: item.id_owner,
    id_worker: item.id_worker,
    owner_email: item.owner_email,
    scopes: item.scopes || [],
    cookies_information: item.cookies_information,
    poll_displayed: Boolean(Number(item.poll_displayed)),
    reservation_form_settings: item.reservation_form_settings,
    reservation_form_banner: item.reservation_form_banner,
  }
}
